import Component from '../core/Component';
import support from '../utils/BrowserSupport'
import ScrollContainer from './ScrollContainer'
import Scroll, { enableScroll, disableScroll } from '../services/Scroll'
import EventBus from '../core/EventBus';
import { IE } from '../core/config'

export const STATES = {
    VISIBLE: 'is-visible',
    ACTIVE: 'is-active',
    ANIMATING: 'is-animating'
}

export default class FullModal extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            scrollContainer: null,
            navigation: null
        }

        this.scrollContainer = null
        this.close = ::this.close
    }

    prepare() {
        this.form = this.element.querySelector('form')
        this.loading = false

        this.element.addEventListener(support.transitionEnd, event => {
            if (event.target === this.element && !this.is(STATES.ACTIVE)) {
                this.element.classList.remove(STATES.VISIBLE)
            }
        })

        if (!IE) {
            this.scrollContainer = new ScrollContainer(this.ref.scrollContainer)

            if (this.scrollContainer) {
                this.scrollContainer.prepare()

                if (this.scrollContainer.scrollbar) {
                    this.scrollContainer.scrollbar.scrollTo(0,0)
                }
            }
        } else {
            Scroll.on('resize', this.handleResize)
            this.handleResize()
        }

        EventBus.on('swup:aftercontentchange', this.close)
    }

    destroy() {
        if (IE) {
            Scroll.off('resize', this.handleResize)
        }

        EventBus.off('swup:aftercontentchange', this.close)
    }

    handleResize = () => {
        this.ref.navigation.style.height = Math.max(document.documentElement.clientHeight, window.innerHeight || 0) + 'px'
    }

    close() {
        if (!this.is(STATES.ACTIVE)) {
            return
        }

        this.element.classList.add(STATES.ANIMATING)
        this.element.classList.remove(STATES.ACTIVE)

        enableScroll()
        this.emit('close')

        EventBus.emit('fullmodal:close', {
            id: this.element.id
        })

        clearTimeout(this.animating)
        this.animating = setTimeout(() => {
            this.element.classList.remove(STATES.ANIMATING)
        }, 800)
    }

    open() {
        disableScroll()
        this.element.classList.add(STATES.VISIBLE)
        this.element.classList.add(STATES.ANIMATING)
        this.element.offsetWidth
        this.element.classList.add(STATES.ACTIVE)
        this.emit('open')

        EventBus.emit('fullmodal:open', {
            id: this.element.id
        })

        clearTimeout(this.animating)
        this.animating = setTimeout(() => {
            this.element.classList.remove(STATES.ANIMATING)
        }, 800)
    }

    toggle() {
        if (this.is(STATES.ACTIVE)) {
            this.close()
        } else {
            this.open()
        }
    }
}